import { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface DrawerProps {
  children: ReactNode;
  isDrawerOpen: boolean;
  animationSpeed?: number;
  zIndex?: number;
  closeCallback: () => void;
}
const Drawer: FC<DrawerProps> = ({
  children,
  isDrawerOpen,
  animationSpeed = 250,
  zIndex = 20,
  closeCallback,
}) => {
  return (
    <div
      style={{ transitionDuration: `${animationSpeed}ms`, zIndex }}
      className={twMerge(
        `h-0 max-h-screen transition-all transform-gpu max-w-full overflow-hidden absolute top-full`,
        isDrawerOpen ? 'h-screen' : 'h-0'
      )}>
      <div
        className={twMerge(
          `max-h-[70%] sm:max-h-[70%] h-full w-screen bg-white text-left overflow-y-auto`
        )}>
        {children}
      </div>
      <div
        onClick={() => {
          closeCallback();
        }}
        className={twMerge(
          'h-full w-screen bg-black/30 backdrop-blur-xs z-21 overflow-hidden cursor-pointer',
          !isDrawerOpen && 'hidden'
        )}
      />
    </div>
  );
};

export default Drawer;
